import { InjectionToken } from "@angular/core";

export const EVENT_SOURCE_URL = new InjectionToken<string>('API_BASE_URL');